import request from '@/utils/request';

export const API_REQUESTS = 'API_REQUESTS';

export const fetchApiRequests = (limit, page, filter_by, filter_value, tab) => async dispatch => {
  const response = await request({
    path: `/v1/admin/api_requests`,
    query: { limit, page, filter_by, filter_value, tab }
  });
  if (response.data) {
    dispatch({
      payload: response,
      type: API_REQUESTS
    });
  }
  return response;
};
